import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useState } from "react";
import { Btn, H4, H6, Image, P } from "../../../AbstractElements";
import { AuthForgotPassword, AuthSignIn, CreateAccount, DontHaveAccount, EmailAddressLogIn, EnterYourEmailPasswordToLogin, OrSignInWith, PasswordLogIn, RememberPassword, SignInToAccount } from "../../../Constant";
import { FormGroup, Input, Label } from "reactstrap";
import { Link } from "react-router-dom";
import { OtherWay } from "./OtherWay";
import { LoginProp, LoginSubmitProp } from "../../../Type/Pages";
import * as Yup from "yup";
import { dynamicImage } from "../../../Service/DynamicImage";

const LoginForm = ({ validation, required, logoClass }: LoginProp) => {
  const [show, setShow] = useState(false);
  const submitHandler = (values: LoginSubmitProp, { resetForm }: { resetForm: () => void }) => {
    resetForm();
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email").required("Email is required"),
    password: Yup.string().required("Password is required"),
  });

  return (
    <div>
      <div>
        <Link className={`logo ${logoClass}`} to={`${process.env.PUBLIC_URL}/dashboard/default`}>
          <Image className="img-fluid for-light" src={dynamicImage("logo/logo_dark.png")} alt="looginpage" />
          <Image className="img-fluid for-dark" src={dynamicImage("logo/logo.png")} alt="looginpage" />
        </Link>
      </div>
      <div className="login-main">
        <Formik initialValues={{ email: "", password: "" }} onSubmit={submitHandler} validationSchema={validation && validationSchema}>
          {() => (
            <Form className="theme-form">
              <H4>{SignInToAccount}</H4>
              <P>{EnterYourEmailPasswordToLogin}</P>
              <FormGroup>
                <Label className="col-form-label">{EmailAddressLogIn}</Label>
                <Field className="form-control" name="email" type="text" placeholder="Test@gmail.com" required={required} />
                <ErrorMessage name="email" component="span" className="pt-1 text-danger" />
              </FormGroup>
              <FormGroup>
                <Label className="col-form-label">{PasswordLogIn}</Label>
                <div className="form-input position-relative">
                  <Field name="password" className="form-control" type={show ? "text" : "password"} placeholder="*********" required={required} />
                  <div className="show-hide" onClick={() => setShow(!show)}>
                    <span className="show"> </span>
                  </div>
                </div>
                <ErrorMessage name="password" component="span" className="pt-1 text-danger" />
              </FormGroup>
              <div className="form-group mb-0">
                <div className="checkbox p-0">
                  <Input id="checkbox1" type="checkbox" />
                  <Label className="text-muted" htmlFor="checkbox1">
                    {RememberPassword}
                  </Label>
                </div>
                <Link className="link" to={`${process.env.PUBLIC_URL}/auth/forget-password`}>
                  {AuthForgotPassword}
                </Link>
                <div className="text-end mt-3">
                  <Btn color="primary" className="btn-block w-100" type="submit">
                    {AuthSignIn}
                  </Btn>
                </div>
              </div>
              <H6 className="text-muted mt-4 or">{OrSignInWith}</H6>
              <OtherWay />
              <P className="mt-4 mb-0 text-center">
                {DontHaveAccount}
                <Link className="ms-2" to={`${process.env.PUBLIC_URL}/auth/sign-up`}>
                  {CreateAccount}
                </Link>
              </P>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default LoginForm;
